import { NotificationsPushAlert } from "@ui-kit/components/index.es";

import classNames from "classnames";
import MainContainer from "pages/_components/MainContainer";
import { resizableRoute } from "pages/_components/Resizable";
import { bool, func } from "prop-types";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import {
    actions as pushNotificationsActions,
    selectors as pushNotificationsSelectors,
} from "reducers/pushNotifications";
import { compose } from "redux";
import * as i18n from "util/i18n";
import * as configUtils from "util/config";
import { waitForEnabled } from "util/pushNotifications";
import { actions as notificationActions } from "reducers/notification";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";

function PushNotification(props) {
    const { dispatch, isConfigured, isEnabled, isFetching, hidden, uxDashboardImprovements } = props;
    const [isPairing, setIsPairing] = React.useState(false);

    const pusNotificationsAlwaysEnabled = configUtils.getBoolean(
        "frontend.show.pushNotification.MobileDevice.functionalities",
        false,
    );
    // Carga inicial de configuración
    useEffect(() => {
        dispatch(pushNotificationsActions.checkConfiguration());
    }, [dispatch]);

    // Si está habilitado, registramos dispositivo y mostramos el widget
    useEffect(() => {
        if (!pusNotificationsAlwaysEnabled) {
            return;
        }
        dispatch(pushNotificationsActions.checkConfiguration());
        if (isConfigured === false && isEnabled === true) {
            // Ya habilitado: registramos dispositivo y mostramos el widget
            dispatch(pushNotificationsActions.pushNotificationsRegisterUserDevice());
            dispatch(pushNotificationsActions.checkConfiguration());
        }
    }, [dispatch, isEnabled, isConfigured]);

    const handleClose = (showAgain) => {
        dispatch(pushNotificationsActions.setHideWidget(true));
        if (showAgain !== undefined) {
            localStorage.setItem("showAgainPushNotification", !showAgain);
        }
    };

    const handleConfigure = async (showAgain) => {
        if (pusNotificationsAlwaysEnabled) {
            const ensureEnabled = async () => {
                if (isEnabled === false) {
                    dispatch(pushNotificationsActions.askPermissions());
                    try {
                        localStorage.setItem("requestedPermission", true);
                        await waitForEnabled(10000);
                        dispatch(pushNotificationsActions.pushNotificationsRegisterUserDevice());
                        return true;
                    } catch (error) {
                        // Silenciamos: puede expirar el timeout si el usuario no acepta permisos
                        return false;
                    }
                }
                return true;
            };
            let enabledAfterWait = true;
            try {
                setIsPairing(true);
                enabledAfterWait = await ensureEnabled();
            } finally {
                setIsPairing(false);
            }
            if (!enabledAfterWait) {
                const message = configUtils.get("backend.pushNotification.devicepairing.error.text");
                dispatch(notificationActions.showNotification(message, "error", ["desktop", "login"]));
            }
            dispatch(pushNotificationsActions.setHideWidget(true));
            dispatch(pushNotificationsActions.checkConfiguration());
        } else {
            if (showAgain !== undefined) {
                localStorage.setItem("showAgainPushNotification", !showAgain);
            }
            dispatch(pushNotificationsActions.setHideWidget(true));
            if (!isEnabled) {
                dispatch(pushNotificationsActions.askPermissions());
            }
            dispatch(push("/settings/notificationsPushDevices"));
        }
    };
    const widgetBody = pusNotificationsAlwaysEnabled
        ? configUtils.get("backend.pushNotification.devicepairing.text")
        : i18n.get("widgets.pushNotifications.modal.body");
    const widgetTitle = i18n.get("widgets.pushNotifications.modal.title");
    const showAgain = localStorage.getItem("showAgainPushNotification");

    let isVisible;

    if (pusNotificationsAlwaysEnabled) {
        isVisible = isPairing === false && isFetching === false && !hidden === true && isConfigured === false;
    } else {
        isVisible =
            isPairing === false &&
            ((isFetching === false && isConfigured === false && isEnabled === false && !hidden === true) ||
                showAgain === null ||
                showAgain === "true");
    }
    return (
        <MainContainer showLoader={isFetching} className={classNames("main-container")}>
            <NotificationsPushAlert
                isVisible={isVisible}
                descriptionText={widgetBody}
                headText={widgetTitle}
                handleGoToConfig={handleConfigure}
                handleCancel={handleClose}
                onlyConfirmFlow={pusNotificationsAlwaysEnabled}
                handleConfirm={handleConfigure}
                isV3={uxDashboardImprovements}
            />
        </MainContainer>
    );
}

PushNotification.propTypes = {
    dispatch: func.isRequired,
    isEnabled: bool,
    isConfigured: bool,
    isFetching: bool,
    hidden: bool,
    uxDashboardImprovements: bool.isRequired,
};

PushNotification.defaultProps = {
    isEnabled: null,
    isConfigured: null,
    isFetching: null,
    hidden: false,
};

const mapStateToProps = (state) => ({
    isEnabled: pushNotificationsSelectors.isEnabled(state),
    isConfigured: pushNotificationsSelectors.isConfigured(state),
    devices: pushNotificationsSelectors.configuredDevices(state),
    isFetching: pushNotificationsSelectors.isFetching(state),
    hidden: pushNotificationsSelectors.isHidden(state),
    uxDashboardImprovements: isUxDashboardImprovementsEnabled(),
});

export default compose(connect(mapStateToProps), resizableRoute)(PushNotification);
